import React from 'preact/compat';

const MinimizeIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <polyline points='4 14 10 14 10 20'></polyline>
    <polyline points='20 10 14 10 14 4'></polyline>
    <line
      x1='14'
      y1='10'
      x2='21'
      y2='3'
    ></line>
    <line
      x1='3'
      y1='21'
      x2='10'
      y2='14'
    ></line>
  </svg>
);

export default MinimizeIcon;
